// removed by extract-text-webpack-plugin
module.exports = {"OasisLogoWrapper":"cJu-lrbkBlyyNvfTAFBfm","OasisLogo":"_2t-pTKsV8XxkkuWM-L9SQx"};


//////////////////
// WEBPACK FOOTER
// ./src/components/OasisLogo.scss
// module id = 1039
// module chunks = 0